// extracted by mini-css-extract-plugin
export default {"container":"CourseSelection__container___celhd","courseSelectionContainer":"CourseSelection__courseSelectionContainer___xDh0k"};